export default __webpack_public_path__ + "74af2cb9540bc6b6f1bedab25c32dade.png";